export default "__VITE_ASSET__b35fb402__"